import { QueryParams } from '../models/query-params';
import { QueryParamsDto } from '../dtos/query-params.dto';

/**
 * Map to QueryParams.
 * @param {object} dto Dto.
 * @returns {QueryParams}
 */
function fromDto(dto) {
  return new QueryParams({
    page: dto.page,
    perPage: dto.per_page,
    sortBy: dto.order_by,
    sortDirection: dto.sort_order,
  });
}

/**
 * Map to QueryParams dto.
 * @param {object} model Model.
 * @param {object} modelFields Model fields.
 * @returns {QueryParamsDto}
 */
function toDto(model, modelFields) {
  const getOrderByValue = value => {
    if (modelFields && modelFields[value]) {
      return modelFields[value];
    }
    return value;
  };
  return new QueryParamsDto({
    page: model.page,
    per_page: model.perPage,
    order_by: getOrderByValue(model.sortBy),
    sort_order: model.sortDirection,
  });
}

export const queryParamsMapper = {
  fromDto,
  toDto,
};
